import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

/**
 * AuthCallback — one-time exchange of session_id from URL fragment.
 * Rendered synchronously when window.location.hash contains "session_id=".
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/portal", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    (async () => {
      try {
        const res = await axios.post(
          `${BACKEND}/api/auth/session`,
          {},
          { headers: { "X-Session-ID": sessionId }, withCredentials: true }
        );
        // Clear the fragment
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Welcome, ${res.data.user.name.split(" ")[0]}`);
        navigate("/portal", { replace: true, state: { user: res.data.user } });
      } catch (e) {
        toast.error("Google sign-in failed. Please retry.");
        navigate("/portal", { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--pta-cream)]">
      <div className="text-center">
        <div className="font-mono-fine text-[11px] tracking-[0.24em] uppercase text-[var(--pta-gold)]">Signing you in…</div>
        <div className="mt-3 font-serif-display text-3xl text-[var(--pta-navy)]">One moment.</div>
      </div>
    </div>
  );
}
